import type { IMosaicTocExpanded, ITocActionUpdateLastMajorVersionSavedAt } from "./interface";

/**
 * Records when the last major-version backup was created.
 *
 * @param state - The current expanded ToC state.
 * @param action - The action containing the backup timestamp.
 * @returns The updated ToC state with the latest backup time recorded.
 */
export const toc_updateLastMajorVersionSavedAt = (
  state: IMosaicTocExpanded,
  action: ITocActionUpdateLastMajorVersionSavedAt,
): IMosaicTocExpanded => ({
  ...state,
  lastMajorVersionSavedAt: action.savedTimeStamp.getTime(),
});
